var _defs, _clipPath, _path, _path2, _circle, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBandeiraBrasil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-18250-13640 42000 29400",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-310 0v-700h630V0zM0-470v120h320v-120"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 7350
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-18250-13640h42000v29400h-42000",
    fill: "#009b3a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-14680 1060 2750 12190 20180 1060 2750-10070Z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#002776",
    r: 7350,
    transform: "translate( 2750 1060)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-22050 14700a17850 17850 0 01 35700 0h-1050a16800 16800 0 10-33600 0",
    fill: "#fff",
    clipPath: "url(#a)",
    transform: "translate( 2750 1060)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009b3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3520-1080a310 350-7 00-80-700 310 350-7 00 80 700m-10-130a190 220-7 00-60-440 190 220-7 00 60 440m580 60 130-10-20-260 280-20a220 220 0 00-30-430l-400 20zm100-400 270-10a90 90 0 00-10-180l-270 10",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2350-1190c-10-100-30-320-180-310l-190 20c220-20 240 200 250 300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2060-1200 330-10a300 300 0 00 290-300v-100a300 300 0 00-300-300l-330 10zm130-140h190a190 190 0 00 180-190v-60a190 190 0 00-190-190h-190",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1170-1210 630 20v-130l-510-20 10-180 400 20v-120l-400-20 10-140 480 20v-130l-600-20zm890 40 120 10 40-480 90 490 110 10 190-470-50 480 120 10 60-700-170-10-180 460-100-490-170-10zm1390 150 630 110 20-130-510-90 40-170 390 60 20-110-390-70 20-140 470 80 20-130-590-100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2500-750 120 30 70-250 270 70a220 220 0 00 110-420l-390-100zm220-340 260 60a90 90 0 00 50-170l-270-70zm630 570 130 40 80-250 260 90a220 220 0 00 140-420l-390-120zm250-330 250 80a90 90 0 00 60-170l-260-80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3920-340c30-100 100-310-50-350l-180-60c210 70 150 280 120 370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4490-140a320 350 21 00 250-650 320 350 21 00-250 650m50-120a190 220 21 00 150-410 190 220 21 00-150 410",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a320 350 0 00 0-700A320 350 0 00 0 0m0-130a190 220 0 00 0-440 190 220 0 00 0 440",
    fillRule: "evenodd",
    clipPath: "url(#b)",
    transform: "rotate(24 2190 12880)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5500-100 250 100-40 90-250-100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5660-40 90 40-140 320-90-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5840 430 120 60 110-230 260 120a220 220 0 00 190-390l-360-180zm290-290 240 120a90 90 0 00 80-160L6210-20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6370 700c50-90 150-290 10-360l-170-80c200 100 100 290 60 380m360 190 550 310 70-110-450-250 90-160 350 200 60-100-350-200 70-120 420 230 60-110-520-290zm1030 350c-40 60 0 120 80 180s140 50 170 10c70-120-370-300-230-510 110-180 320-40 390 10s200 180 110 320l-130-80c40-60-10-130-70-170-70-40-120-60-160 0-70 100 370 280 230 490-90 160-270 90-380 20-100-60-240-210-150-360zm750 490c-40 60-10 130 70 190s140 60 170 20c80-120-350-320-210-520 130-170 330-20 400 30s190 190 80 320l-120-80c40-70 0-130-60-170-70-50-120-70-160-10-70 90 350 300 210 500-110 150-270 70-380-10-100-60-230-220-130-360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9120 2480a320 350 38 00 430-550 320 350 38 00-430 550m80-100a190 220 39 00 270-350 190 220 39 00-270 350",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBandeiraBrasil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bandeira-brasil.5412cb32b3abb5573fc434194432dddc.svg";